export default __webpack_public_path__ + "static/media/briefcase.108623c7.svg";